<template>
	<div id="credenciais">
		<a-row type="flex" justify="space-between" align="bottom">
			<a-col :span="5">
				<!-- <a-input-search
					v-model="strSearch"
					:maxLength=100
					placeholder="Insira o nome a ser pesquisado"
					@search="onSearch"					
					:disabled="loading"
				>
				<a-button slot="enterButton" type="primary" :disabled="loading">Pesquisar</a-button>
				</a-input-search> -->
				<a-row>
					<span>Tribunal:</span>
				</a-row>
				<a-row>
					<a-input
						style="width: 100%;"
						placeholder="Tribunal"
						v-model="valueTribunal"			
						@change="onChangeTribunal"						
						:disabled="loading"			
						>					
					</a-input>
				</a-row>
			</a-col>
			<a-col :span="3">
				<a-row>
					<span>Poder e Estado:</span>
				</a-row>
				<a-row>
					<a-select
						placeholder="Filtrar por poder e estado"
						style="width: 120%;"
						@change="handlePoderEstadoChange"
						v-model="podersEstadosSelecionado"
						:allowClear="podersEstadosSelecionado !== '0.0'"
						>
						<a-select-option :value="'0.0'">Todos</a-select-option>
						<a-select-option
							v-for="poderEstado in filteredPodersEstados"
							:key="`${poderEstado.poderJudiciario}.${poderEstado.codigoEstado}`"
							:value="poderEstado"
						>
							{{ `${poderEstado.poderJudiciario}.${poderEstado.codigoEstado}` }}
						</a-select-option>
				</a-select>
				</a-row>
			</a-col>
			<a-row>
				<a-col :span="18" :offset="4">
				  <span>Instância:</span>
				  <a-select
					style="width: 95%;"
					@change="onChangeInstancia"
					:value="valueInstancia"
					:disabled="loading"
					:allowClear="valueInstancia!='3'"
				  >
					<a-select-option value="3">Todos</a-select-option>
					<a-select-option value="1">1º</a-select-option>
					<a-select-option value="2">2º</a-select-option>
				  </a-select>
				</a-col>  
			  </a-row>
			  <a-col :span="4">
				<a-row>
					<span>Usuário do Fornecedor:</span>
				</a-row>
				<a-row>
					<a-input
						style="width:99%;"
						placeholder="Usuário"
						v-model="valueUsuario"		
						@change="onChangeUsuario"						
						:disabled="loading"	
						>					
					</a-input>
				</a-row>
			</a-col>
			<a-col :span="2">
				<span>Situação:</span>
				<a-select
				  style="width:100%;"
				  @change="onChangeAtivo"
				  :value="valueAtivo"
				  :disabled="loading"
				  :allowClear="valueAtivo!='3'"
				>
				  <a-select-option value="3">Todos</a-select-option>
				  <a-select-option value="1">Ativo</a-select-option>
				  <a-select-option value="0">Inativo</a-select-option>
				</a-select>
			</a-col>
			  <a-col :span="2" style="text-align: right;">
				<a-button
					class="tr-search-btn"
					style="width: 110px;"
					type="primary"
					@click.prevent="carregarCredenciais"
					:disabled="loading"
					icon="search"
				>Pesquisar</a-button>
			</a-col>
			<a-col :span="4" style="text-align: right;">
				<a-button
					type="primary"						
					class="tr-search-btn"
					style="width: 120px;"
					@click.stop.prevent="onNewCredencial"
					:disabled="loading"
					icon="plus-circle"
					v-if="habilitarFuncionalidade('PermitirIncluir')"
				>Credencial</a-button>
			</a-col>
		</a-row>

		<a-row style="height: calc(100vh - 230px); overflow-y: auto; overflow-x: auto; min-height: 100px;">
			<a-table
				:columns="columns"
				:rowKey="record => record.idCredencial"
				:dataSource="data"
				:loading="{spinning:loading, tip:'Carregando...'}"
				:pagination="pagination"
				@change="handleTableChange"
				size="middle"
			>
				<template
						slot="tipoCredencial"
						slot-scope="tipoCredencial, record"
					>{{formatarTipoCredencial(record.tipoCredencial)}}
				</template>
				<template slot="ativa" slot-scope="ativa, record">					
					<a-icon type="check-circle" class="sucess" v-if="record.ativa"/>
					<a-icon type="close-circle" class="danger" v-else/>					
				</template>
				<template slot="editar" slot-scope="editar, record">
					<div>
						<a-tooltip>
							<template slot="title">Editar credencial</template>
							<a-icon 
								type="form" 
								class="cursor"
								@click="handleEditarCredencial(record)"/>
						</a-tooltip>
					</div>
				</template>
				<template slot="produtoID" slot-scope="produtoID,record">
					<a-icon
					  type="plus-circle"
					  style="margin-left: 45%;"
					  @click="BuscarCredProdutoColumn(record.idCredencial)"
					  class="cursor"
					/>
				</template>
			</a-table>
			<modal-component        
				class="modal-component"
				title="Produtos"
				ref="modalDetalhamento"
				width="20%"
				:style="{ maxHeight: '15vh' }" 
				:maskClosable="false">
				<a-table
					:columns="columnsDetalhado"
					:rowKey="record => record.idCredencial"
					:dataSource="credencial.produto"
					:pagination="paginationModal"
					@change="handleTableChangeModal"
					size="middle">
				</a-table>
			</modal-component>
			<a-row type="flex" align="bottom">
				<a-col :span="6" style="text-align: right;">
					<a-button
						class="tr-search-btn"
						type="primary"
						@click.prevent="onDownloadPlanModelo()"
						:disabled="loading"
						icon="download"
					>Download Planilha</a-button>
				</a-col>
				<a-col :span="3" style="text-align: right; margin-left: 10px;">
					<a-button
						type="primary"
						class="tr-search-btn"
						@click.prevent="onShowModalImportPlanilha()"
						:disabled="loading"
						icon="cloud-upload"
						>
						Importar Planilha</a-button>
				</a-col>
			</a-row>

			<modal-component
				class="modal-component"
				title="Editar Credencial"
				ref="modaleditcred"
				width="50%"
				:maskClosable="false"
			>
			<a-row>
				<a-col :span="20" >
					<span class="tr-label">Tribunal:</span>
					<br>
					<a-select
					  placeholder="Selecione o tipo acesso do usuário"
					  style="width: 100%;"
					  @change="handleChangeCredencialFonte"
					  :value="valueCredencialFonte"
					  >
					  <a-select-option v-for="credencialFontes in credencialFontes" :key="credencialFontes.idDivisaoTribunal">
						{{credencialFontes.nome}}
					</a-select-option>
					</a-select>
				  </a-col>
				  <a-col :span="3" :offset="1">
					<span>Instância:</span>
				   <a-input tyle="width: 70%;" 
				   			:allowClear="credencial.instancia!=''"
							v-model="credencial.instancia"
							:disabled="true"/>
				 </a-col>
			</a-row>
			<a-row>
			<span class="tr-label">Login:</span>					
				<a-input-password
						:maxLength=100
						placeholder="Insira o CPF ou OAB" 
						v-model="credencial.usuario"
						:allowClear="credencial.usuario!=''"
						:disabled="$store.state.auth.idPerfilPortal === 1 || $store.state.auth.idPerfilPortal === 2"
						v-if="$store.state.auth.idPerfilPortal === 1 || $store.state.auth.idPerfilPortal === 2"
					>
						<a-icon slot="prefix" type="user"/>
					</a-input-password>
					<a-input 
							placeholder="Insira a Quantidade de acesso para a credencial"
							v-model="credencial.usuario"
						    :allowClear="credencial.usuario!=''"
							v-else
						>
							<a-icon slot="prefix" type="plus-circle"/>
				</a-input>

			</a-row> 	
			<a-row>
				<span class="tr-label">Senha:</span>					
				<a-input-password
					:maxLength=100
					placeholder="Insira a senha" 
					v-model="credencial.senha" 
					:allowClear="credencial.senha!=''"
					:disabled="$store.state.auth.idPerfilPortal === 1 || $store.state.auth.idPerfilPortal === 2"
					v-if="$store.state.auth.idPerfilPortal === 1 || $store.state.auth.idPerfilPortal === 2"
				>
					<a-icon slot="prefix" type="lock"/>
				</a-input-password>
				<a-input-password 
							placeholder="Insira a Quantidade de acesso para a credencial"
							v-model="credencial.senha"
						    :allowClear="credencial.senha!=''"
							v-else
						>
						<a-icon slot="prefix" type="lock"/>
				</a-input-password>
				<a-row>
					<span class="tr-label">Usuário do Fornecedor:</span>					
					<a-input
						:maxLength=100
						placeholder="" 
						v-model="credencial.login"
						@change="onChangeLogin"
						:disabled="true"
					>
						<a-icon slot="prefix" type="user"/>
					</a-input>
				</a-row>
				</a-row>
				<a-row v-if="($store.state.auth.idPerfilPortal!=3)">
					<span>Ordem:</span>					
					<a-input
						placeholder="Insira a ordem da credencial"
						v-model="credencial.ordem"
						:allowClear="credencial.ordem!=''"
					>
						<a-icon slot="prefix" type="ordered-list"/>
					</a-input>
				</a-row>
				<a-row v-if="($store.state.auth.idPerfilPortal!=3)">	
					<span>Qtd Acesso diario:</span>					
						<a-input  
						    type="number"
							@input="validarNumero"
							placeholder="Insira a Quantidade de acesso para a credencial"
							v-model="credencial.limite"
							:allowClear="credencial.limite !== ''"
						>
						</a-input>
				</a-row>
				<a-row v-if="($store.state.auth.idPerfilPortal != 3)">
					<a-col :span="30">
						<span>Produtos:</span>
						<br>
						<a-select
							mode="multiple"
							placeholder="Selecione os produtos"
							style="width: 100%;"
							v-model="produtosSelecionados"
							@change="handleProdutoSelectionChange"
						>
							<a-select-option value="0">Todos</a-select-option>
							<a-select-option v-for="credencialproduto in credencialProdutos" :key="credencialproduto.idproduto" :value="credencialproduto.idproduto">
							{{ credencialproduto.produto }}
							</a-select-option>
						</a-select>
					</a-col>
				</a-row>	
				<a-row v-if="$store.state.auth.idPerfilPortal === 1 || $store.state.auth.idPerfilPortal === 2">
					<a-col :span="24">
						<span class="tr-label">Tipo de Captura:</span>

						<a-select
							placeholder="Selecione o tipo de captura"
							style="width: 100%;"
							v-model="credencial.tipoDocumentoCaptura"
						>
							<a-select-option :value="2">
								Íntegra
							</a-select-option>

							<a-select-option :value="1">
								Inicial
							</a-select-option>
						</a-select>
					</a-col>
				</a-row>
				<a-row v-if="$store.state.auth.idPerfilPortal === 1 || $store.state.auth.idPerfilPortal === 2">
					<a-col :span="24">
							<span class="tr-label">Tipo Credencial:</span>						
							<a-select
								placeholder="Selecione o tipo de crendecial"
								style="width: 100%;"
								v-model="credencial.tipoCredencial"
								@change="handleSelecttipoPerfilChange"
							>
								<a-select-option
									v-for="tpTipoCredencial in tpTipoCredencialData"
									:key="tpTipoCredencial.key"
									:value="tpTipoCredencial.key"
								>{{tpTipoCredencial.descricao}}</a-select-option>
							</a-select>
						</a-col> 
				</a-row>
				<a-row>
					<a-col :span="24">
							<span>Código MFA:</span>						
							<a-input
								:maxLength=50
								placeholder="" 
								v-model="credencial.codigoMfa"
							/>
						</a-col> 
				</a-row>
				<a-row
					v-if="$store.state.auth.idPerfilPortal === 1 && credencial.tipoCredencial === 2"
					type="flex" 
					justify="space-between"
					align="middle"
					style="margin: 15px 0;"
					>
					<a-col :span="6" style="display: flex; align-items: center; justify-content: flex-start;">
						<a-switch
						v-model="credencial.jusBr"
						@change="handlerSwitchChangeJusBr"
						defaultChecked
						>
						<a-icon type="check" slot="checkedChildren" />
						<a-icon type="close" slot="unCheckedChildren" />
						</a-switch>
						<span style="margin-left: 10px;">Jus BR</span>
					</a-col>
				</a-row>
				<a-row v-if="(this.credencial.ativa == false)">
					<span>Motivo para a desativação:</span>					
					<a-textarea
						placeholder="Informe o motivo, para a desativação da credencial"
						no-resize
						v-model="credencial.observacao"
						:allowClear="credencial.observacao!=''"
					>
						<a-icon slot="prefix" type="plus-circle"/>
					</a-textarea>
				</a-row>
				<!-- <a-row style="margin-top: 15px;">				
				<a-col :span="24" style="text-align: left; background-color: #eaeaea;">
					<div style="margin: 15px 20px 10px 20px;">							
						<span style="font-weight: 400; font-size: 16px;" v-html="textoTermo"/>
					</div>
				</a-col>					
				</a-row>
				<a-row style="margin-top: 5px;">
					<a-checkbox @change="onChangeCheck" :checked="termoAceite">
						Li e aceito os termos
					</a-checkbox>
				</a-row> -->
				<span slot="buttons">
					<a-row type="flex" align="middle">
						<a-col :span="12" style="text-align: left;">
							<a-switch style="margin-left: 15px;" defaultChecked v-model="credencial.ativa" @change="handlerSwitchChange">
								<a-icon type="check" slot="checkedChildren"/>
								<a-icon type="close" slot="unCheckedChildren"/>
							</a-switch>
							<span style="margin-left: 10px;" v-if="credencial.ativa">Ativo</span>
							<span style="margin-left: 10px;" v-else>Inativo</span>
						</a-col>
						<a-col :span="12">
							<a-row type="flex" justify="end" align="middle" :gutter="40">
								<a-col>
									<a-button key="back" class="credencial-form-button" @click.prevent="handleCancelEditCredencialModal">Retornar</a-button>
								</a-col>
								<a-col>
									<a-button
										key="submit"
										class="credencial-form-button"
										type="primary"
										@click.prevent="handleOkEditCli" 
										v-if="habilitarFuncionalidade('PermitirAlterar')"
									>Salvar</a-button>
								</a-col>
							</a-row>
						</a-col>
					</a-row>
				</span>
			</modal-component>
			<modal-component
				class="modal-component"				
				title="Nova Credencial"
				ref="modalnewcred"
				width="50%"
				:maskClosable="false"
			>
				<a-row>
					  <a-col :span="20">
						<span class="tr-label">Tribunal:</span>
						<br>
						<a-select
						  placeholder="Selecione o Tribunal"
						  style="width: 100%;"
						  @change="handleChangeCredencialFonte"
						  :value="valueCredencialFonte"
						>
						  <a-select-option v-for="credencialFontes in credencialFontes" :key="credencialFontes.idDivisaoTribunal">
							{{ credencialFontes.nome }}
						  </a-select-option>
						</a-select>
						<!-- <a v-if="selectedCredencialFonte && selectedCredencialFonte.links && selectedCredencialFonte.links.length > 0" href="#" @click.prevent="openLink(selectedCredencialFonte.links)">
							Clique aqui para acessar o Tribunal
						  </a> -->
					  </a-col>
					  <a-col :span="3" :offset="1">
						<span>Instância:</span>
						<a-select
						  style="width: 70%;"
						  v-model="selectedInstancia"
						  :allowClear="credencial.instancia !== ''"
						  :disabled="false"
						  :default-value="1"
						>
						  <a-select-option :value="1" @click="credencial.instancia = 1">1</a-select-option>
						  <a-select-option :value="2" @click="credencial.instancia = 2">2</a-select-option>
						</a-select>
				     </a-col>
				</a-row>
				<a-row>
				<span class="tr-label">Login:</span>					
					<a-input
					  :maxLength="11"
					  placeholder="Insira o CPF ou OAB" 
					  v-model="credencial.usuario"
					  :allowClear="credencial.usuario !== ''"
					  @input="validarCPF_OAB"
					  :class="{ 'campo-invalido': campoInvalido && credencial.usuario !== '' }"
					>
					  <a-icon slot="prefix" type="user"/>
					</a-input>
					<p :style="{ color: campoInvalido && credencial.usuario !== '' ? 'red' : '' }" v-if="campoInvalido && credencial.usuario !== ''">Formato inválido! Ex:CPF:99999999999 ou OAB:UF999999</p>
				</a-row> 
				<a-row>
					<span class="tr-label">Senha:</span>					
					<a-input-password
						:maxLength=100
						placeholder="Insira a senha" 
						v-model="credencial.senha" 
						:allowClear="credencial.senha!=''"
					>
						<a-icon slot="prefix" type="lock"/>
					</a-input-password>
				</a-row>

				<a-row>
					<span class="tr-label">Usuário do Fornecedor:</span>					
					<a-input
						:maxLength=100
						placeholder="" 
						:value="valueLogin"
						@change="onChangeLogin"
						:disabled="true"
					>
						<a-icon slot="prefix" type="user"/>
					</a-input>
				</a-row>
				<a-row v-if="($store.state.auth.idPerfilPortal!=3)">
					<span>Ordem:</span>					
					<a-input
						placeholder="Insira a ordem da credencial"
						v-model="credencial.ordem"
						:allowClear="credencial.ordem!=''"
					>
						<a-icon slot="prefix" type="ordered-list"/>
					</a-input>
				</a-row>
				<a-row v-if="($store.state.auth.idPerfilPortal!=3)">
					<span>Qtd Acesso diario:</span>					
						<a-input 
						    type="number"
							@input="validarNumero"
							placeholder="Insira a Quantidade de acesso para a credencial"
							v-model="credencial.limite"
							:allowClear="credencial.limite !== ''"
							>
							<a-icon slot="prefix" type="plus-circle"/>
						</a-input>
				</a-row>
				<a-row v-if="($store.state.auth.idPerfilPortal != 3)">
					<a-col :span="30">
					  <span>Produtos:</span>
					  <br>
					  <a-select
						mode="multiple"
						placeholder="Selecione os produtos"
						style="width: 100%;"
						v-model="produtosSelecionados"
						@change="handleProdutoSelectionChange"
					  >
						<a-select-option value="0">Todos</a-select-option>
						<a-select-option v-for="credencialproduto in credencialProdutos" :key="credencialproduto.idproduto" :value="credencialproduto.idproduto">
						  {{ credencialproduto.produto }}
						</a-select-option>
					  </a-select>
					</a-col>
				  </a-row>
				  <a-row v-if="$store.state.auth.idPerfilPortal === 1 || $store.state.auth.idPerfilPortal === 2">
						<a-col :span="24">
							<span class="tr-label">Tipo de Captura:</span>

							<a-select
								placeholder="Selecione o tipo de captura"
								style="width: 100%;"
								v-model="credencial.tipoDocumentoCaptura"
							>
								<a-select-option :value="2">
									Íntegra
								</a-select-option>

								<a-select-option :value="1">
									Inicial
								</a-select-option>
							</a-select>
						</a-col>
				  </a-row>
				  <a-row v-if="$store.state.auth.idPerfilPortal === 1 || $store.state.auth.idPerfilPortal === 2">
					<a-col :span="24">
							<span class="tr-label">Tipo Credencial:</span>						
							<a-select
								placeholder="Selecione o tipo de crendecial"
								style="width: 100%;"
								v-model="credencial.tipoCredencial"
								@change="handleSelecttipoPerfilChange"
							>
								<a-select-option
									v-for="tpTipoCredencial in tpTipoCredencialData"
									:key="tpTipoCredencial.key"
									:value="tpTipoCredencial.key"
								>{{tpTipoCredencial.descricao}}</a-select-option>
							</a-select>
						</a-col>
				</a-row>
				<a-row>
					<a-col :span="24">
							<span>Código MFA:</span>						
							<a-input
								:maxLength=50
								placeholder="" 
								v-model="credencial.codigoMfa"
							/>
						</a-col> 
				</a-row>	
				<a-row
					v-if="$store.state.auth.idPerfilPortal === 1 && credencial.tipoCredencial === 2"
					type="flex" 
					justify="space-between"
					align="middle"
					style="margin: 15px 0;"
					>
					<a-col :span="6" style="display: flex; align-items: center; justify-content: flex-start;">
						<a-switch
						v-model="credencial.jusBr"
						@change="handlerSwitchChangeJusBr"
						defaultChecked
						>
						<a-icon type="check" slot="checkedChildren" />
						<a-icon type="close" slot="unCheckedChildren" />
						</a-switch>
						<span style="margin-left: 10px;">Jus BR</span>
					</a-col>
				</a-row> 
				<a-row style="margin-top: 15px;">				
				<a-col :span="24" style="text-align: left; background-color: #eaeaea;">
					<div style="margin: 15px 20px 10px 20px;">							
						<span style="font-weight: 400; font-size: 16px;" v-html="textoTermo"/>
					</div>
				</a-col>					
				</a-row>
				<a-row style="margin-top: 5px;">
					<a-checkbox @change="onChangeCheck" :checked="termoAceite">
						Li e aceito os termos
					</a-checkbox>
				</a-row>
				<span slot="buttons">
					<a-row type="flex" align="middle">
						<a-col :span="12" style="text-align: left;">														
						</a-col>
						<a-col :span="12">
							<a-row type="flex" justify="end" align="middle" :gutter="40">
								<a-col>
									<a-button key="back" class="credencial-form-button" @click.prevent="handleCancelNewCred">Retornar</a-button>
								</a-col>
								<a-col>
									<a-button
										key="submit"
										class="credencial-form-button"
										type="primary"
										@click.prevent="handleOkNewCred"
										:disabled="!termoAceite"
									>Salvar</a-button>
								</a-col>
							</a-row>
						</a-col>
					</a-row>					
				</span>
			</modal-component>
			<modal-component
			class="modal-component"
			title="Carregar Planilha"
			ref="modalCarregarPlanilha"
			width="40%"
			:maskClosable="false"
		>
			<a-row>				
				<a-upload :file-list="fileListUpload" :remove="handleRemoveFile" :before-upload="beforeUploadFile" accept=".xlsx,.xls">
      				<a-button> <a-icon type="upload"/> Selecionar Arquivo </a-button>
    			</a-upload>
			</a-row>
			<a-row style="margin-top: 10px;">				
				<a-col :span="24" style="text-align: left; background-color: #eaeaea;">
					<div style="margin: 15px 20px 10px 20px;">							
						<span style="font-weight: 400; font-size: 16px;" v-html="textoTermo"/>
					</div>
				</a-col>
			</a-row>
			<a-row style="margin-top: 5px;">
				<a-checkbox @change="onChangeCheck" :checked="termoAceite">
					Li e aceito os termos
				</a-checkbox>
			</a-row>
			<span slot="buttons">
				<a-row type="flex" align="middle">					
					<a-col :span="23" >
						<a-row type="flex" justify="end" align="middle" :gutter="40">
							<a-col>
								<a-button
									type="primary"
									class="tr-search-btn"
									style="width: 130px;"
									@click.prevent="onImportarPlanilha()"
									:disabled="!termoAceite"
									>
									Enviar</a-button>
							</a-col>
							<a-col>
									<a-button key="back" class="cliente-form-button" @click.prevent="handleCancelPlanImport">Retornar</a-button>
							</a-col>
						</a-row>
					</a-col>
				</a-row>
			</span>
		</modal-component>
		</a-row>
	</div>
</template>

<script>
import PortalCredencialWebApi from "@/API/PortalCredencialWebApi";
import ModalComponent from "@/components/ModalComponent";
import moment from "moment";
import { showNotificationError } from "@/util/showNotification";
import { showNotificationSucess } from "@/util/showNotification";
import Helpers from "@/util/Helpers";
// import { LOAD_TELAPERFISPORTAL, LOAD_PERFISPORTAL, LOAD_MENU } from '@/store/actions'

const tpTipoCredencialData = [{ key:1, descricao:"Dado" }, { key:2, descricao:"Autos" }, { key:3, descricao:"Autos/Dado" }];

const columns = [
	{
		title: "Tribunal",
		dataIndex: "nome",
		width: "9%",
		sorter: (a, b) => a.nome.localeCompare(b.nome),		
		scopedSlots: { customRender: "nome" }
	},
	{
        key: 'poderJudiciario',
		title: "Poder Judiciário",
		dataIndex: "poderJudiciario",
		align: "center",
		width: "5%",
        scopedSlots: { customRender: "poderJudiciario" },
        sorter: (a, b) => a.poderJudiciario - b.poderJudiciario		
	},
	{
        key: 'codigoEstado',
		title: "Código Estado",
		dataIndex: "codigoEstado",
		align: "center",
		width: "5%",
		scopedSlots: { customRender: "codigoEstado" },
		sorter: (a, b) => a.codigoEstado - b.codigoEstado
    },
	{
		title: "Instância",
		dataIndex: "instancia",
		align: "center",
		sorter: (a, b) => a.instancia.localeCompare(b.instancia),
		width: "5%",
		scopedSlots: { customRender: "Instancia" }
	},
	{
		title: "Usuario",
		dataIndex: "login",
		sorter: (a, b) => a.login.localeCompare(b.login),
		width: "5%",
		scopedSlots: { customRender: "login" }
	},
	{
		title: "Produtos",
		width: "2%",
		align: "left",
		scopedSlots: { customRender: "produtoID" }
  	},
	{
		title: "Ordem",
		dataIndex: "ordem",
		align: "center",
		sorter: (a, b) => a.ordem.localeCompare(b.ordem),
		width: "4%",
		scopedSlots: { customRender: "ordem" }
	},
	{
		title: "Contador",
		dataIndex: "contador",
		align: "center",
		sorter: (a, b) => a.contador.localeCompare(b.contador),
		width: "5%",
		scopedSlots: { customRender: "contador" }
	},
	{
		title: "Qtd Acesso diario",
		dataIndex: "limite",
		align: "center",
		sorter: (a, b) => a.limite.localeCompare(b.limite),
		width: "5%",
		scopedSlots: { customRender: "Qtd Acesso diário" }
	},
	{
		title: "Tipo Credencial",
		dataIndex: "tipoCredencial",
		align: "center",
		width: "6%",
		scopedSlots: { customRender: "tipoCredencial" },
		sorter: (a, b) => moment(a.tipoCredencial) - moment(b.tipoCredencial)
	},
	{
		title: "Situação",
		dataIndex: "ativa",
		sorter: (a, b) => a.ativa - b.ativa,		
		align: "center",
		width: "5%",
		scopedSlots: { customRender: "ativa" }
	},	
	{
		key: "IdCredencial",
		title: "Editar",
		dataIndex: "editar",
		align: "center",
		width: "5%",
		scopedSlots: { customRender: "editar" }
	}
];

const columnsDetalhado = [
	{
		title: "Nome",
		dataIndex: "descricaoProduto",
		width: "9%",
		sorter: (a, b) => a.descricaoProduto.localeCompare(b.descricaoProduto),		
		scopedSlots: { customRender: "descricaoProduto" }
	},
]  
export default {	
	name: "credenciais",
	data() {
		return {
			idTela: 4,
			data: [],
			pagination: {},
			loading: false,
			columns,
			columnsDetalhado,
			fileListUpload: [],
			strSearch: null,
			searchText: "",
			searchInput: null,
			textoTermo: '',
			credencial: {
				idCredencial: 0,
				idDivisaoTribunal: 0,
				nome: "",
				ativa: false,
				usuario: "",
				senha: "",
				tipoLinkDivisao: 0,
				legado: 0,
				classe: "",
				ordem: 0 ,
				limite: 0,
				contador: 0,
				idUsuarioAlteracao: 0,
				idUsuarioCadastro: 0,
				tipoCredencial: 0 ,
				observacao: "",
				statusTermoUso: false,
				instancia : "",
				links: "",
				codigoEstado:0,
				poderJudiciario:0,
				login:"",
				produto:[],
				jusBr: false,
				codigoMfa: "",
				tipoDocumentoCaptura: 2
			},
			idFonte: 0,
			credencialFontes: [],
			perfisPortalCompleto: [],
			valueCredencialFonte: null,
			tpTipoCredencialData,
			termoAceite: false,
			selectedCredencialFonte: null,
			selectedInstancia: null,
			selectedUrl: '',
			filtros:{},
			valueUsuario: '',
			valueLogin: '',
			valueTribunal: '',
			valueInstancia: '3',
			valueAtivo : '3',
			podersEstados: [],
			podersEstadosSelecionado: '0.0',
			valueNumeric: '',
			campoInvalido: false,
			credencialProdutos: [],
			produtosSelecionados: [],
			selectedCredencialProduto: null,
		};
	},
	computed: {
	filteredPodersEstados() {
		const uniqueValues = [];

		return this.podersEstados
			.filter((poderEstado) => {
				const valueKey = `${poderEstado.poderJudiciario}.${poderEstado.codigoEstado}`;

				if (!uniqueValues.includes(valueKey)) {
					uniqueValues.push(valueKey);
					return true;
				}

				return false;
			})
			.sort((a, b) => {
				const poderDiff =
					Number(a.poderJudiciario) - Number(b.poderJudiciario);

				if (poderDiff !== 0) {
					return poderDiff;
				}

				return Number(a.codigoEstado) - Number(b.codigoEstado);
			});
	},
},
	mounted() {     
		// this.fetch({ search: true });   
		this.textoTermo = this.$store.state.global.termoAceiteAdv;
		this.carregarCredenciais()	
		this.carregarPoderCodigo()
	},
	watch:{
		'credencial.tipoCredencial'(novoValor) {
			if (novoValor !== 2) {
			this.credencial.jusBr = false;
			}
		}
	},
	methods: {
		carregarPoderCodigo() {
			his.podersEstados = [
				...new Set(
					this.$store.state.access.poderesCodEstado.map(t => {
						return `${t.poderJudiciario}.${t.codigoEstado}`;
					})
				)
			];
		},
		validarCPF_OAB() {
			const regexCPF = /^\d{11}$/;
			const regexOAB = /^\w{1,8}$/;
			this.credencial.usuario = this.credencial.usuario.toUpperCase()
			if (regexCPF.test(this.credencial.usuario) || regexOAB.test(this.credencial.usuario)) {
				this.campoInvalido = false;
			} else {
				this.campoInvalido = true;
			}

		},
		// --------Chamadas endopoints - APIs -----------------//
		getCredencialFonte(){
			this.credencialFontes = [];			
			PortalCredencialWebApi.getCredencialFonte()
				.then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Cadastro de Credencial", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Cadastro de Credencial", res.data.result);
					} else {
						this.credencialFontes.push.apply(this.credencialFontes, res.data.result.map(h => {
								return { idDivisaoTribunal: h.idDivisaoTribunal, nome: h.nome, links: h.links, instancia: h.instancia}
							}));		
						this.credencialFontes = this.credencialFontes.filter(c => !/jus[\s\.]*br/i.test(c.nome))				
						this.valueCredencialFonte = "";
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Cadastro de Credencial", "Erro ao tentar carregar Fontes.");
				});
		},
		getProdutos(){
			this.credencialProdutos = [];			
			PortalCredencialWebApi.getProdutos()
				.then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Cadastro de Credencial", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Cadastro de Credencial", res.data.result);
					} else {
						this.credencialProdutos.push.apply(this.credencialProdutos, res.data.result.map(h => {
								return { idproduto: h.idProduto, produto: h.produto}
							}));                                                                                           
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Cadastro de Credencial", "Erro ao tentar carregar Fontes.");
				});
		},

		getCredencialProduto(idCredencial){
			this.credencial.produto = [];			
			PortalCredencialWebApi.getCredencialProduto(idCredencial)
				.then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Cadastro de Credencial", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Cadastro de Credencial", res.data.result);
					} else {
						this.credencial.produto.push.apply(this.credencial.produto, res.data.result.map(h => {
								return { idcredencial: h.idCredencial, idDivisaoTribunal: h.idDivisaoTribunal, produtoId: h.produtoID}
							}));  
							const validacaoProdutos = this.credencial.produto.map(produto => produto.produtoId);
							this.produtosSelecionados = validacaoProdutos.length > 0 ? validacaoProdutos : ["0"];
						}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Cadastro de Credencial", "Erro ao tentar carregar Fontes.");
				});
		},

		BuscarCredProdutoColumn(idCredencial){		
			PortalCredencialWebApi.BuscarCredProdutoColumn(idCredencial)
			.then(res => {
				if (res.data.statusCode != 200) {
					this.error("Produtos Credencial", res.data.errorMessage);
					return;
				};          
				this.credencial.produto = res.data.result.map(s => {
					return {
						idcredencial: s.idcredencial,
						idDivisaoTribunal: s.idDivisaoTribunal,
						produtoId: s.produtoID,
						descricaoProduto: s.descricaoProduto
					};
				});
				if (this.credencial.produto.length == 0) {
					showNotificationSucess(this, "Produtos", "Todos os Produtos estão vinculados a está credencial");
				}
				else{
					this.$refs.modalDetalhamento.showModal();
				}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Produtos", "Erro ao tentar Buscar Produtos.");
				});
    	},	
		pesquisar() {
			this.data = [];
			this.loading = true;
			let filtro = { idUsuario: this.valueCredencial != null ? this.valueCredencial : 0};			
			PortalCredencialWebApi.controleContratos(filtro).then(res => {
				this.loading = false;				
				if (res.data.statusCode != 200) {
					showNotificationError(this, "Controle Contrato", res.data.errorMessage);
					return;
				} else if (typeof res.data.result == "string") {
					showNotificationSucess(this, "Controle Contrato", res.data.result);
				} else {
					this.data = res.data.result;
					this.pagination = { current: 1 };
				}
			})
			.catch(res => {				
				this.loading = false;
				showNotificationError(this, "Controle Contrato", "Erro Controle Contrato.");
			});
		},
		getCredencialFonte(){
			this.credencialFontes = [];			
			PortalCredencialWebApi.getCredencialFonte()
				.then(res => {
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Cadastro de Credencial", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Cadastro de Credencial", res.data.result);
					} else {
						this.credencialFontes.push.apply(this.credencialFontes, res.data.result.map(h => {
								return { idDivisaoTribunal: h.idDivisaoTribunal, nome: h.nome, links: h.links, instancia: h.instancia}
							}));		
						this.credencialFontes = this.credencialFontes.filter(c => !/jus[\s\.]*br/i.test(c.nome))				
						this.valueCredencialFonte = "";
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Cadastro de Credencial", "Erro ao tentar carregar Fontes.");
				});
		},
		handleOkNewCred() {
			if (!this.validarCampos(this.credencial)){
				return;
			}
			this.$root.loadingSpinner = true;
			this.idFonte = this.valueCredencialFonte;
			this.credencial.idUsuarioCadastro = this.$store.state.auth.idUser;
			this.credencial.ativa = true;
			if(this.credencial.tipoCredencial != 2){
				this.credencial.jusBr = false
			}
			PortalCredencialWebApi.inserirCredencial(this.credencial, this.idFonte, this.$store.state.auth.idPerfilPortal,this.produtosSelecionados )
				.then(res => {
					this.$refs.modalnewcred.handleCancel();
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Cadastro de Credencial", res.data.result);
					} else {
						showNotificationError(this, "Cadastro de Credencial", res.data.errorMessage);
					}					
					// this.fetch({ search: true, Text: this.textFilter });	
					this.carregarCredenciais()			
				})
				.catch(res => {
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Cadastro de Credencial", "Erro ao tentar inserir credencial.");
				});
		},
		carregarCredenciais() {
			this.getCredencialFonte()
			this.getProdutos()
			this.loading = true;
			this.podersEstados = []
		
			this.filtros.idUsuario = this.$store.state.auth.idUser
			this.filtros.idPerfil = this.$store.state.auth.idPerfilPortal
			this.filtros.poderJudiciario = (this.podersEstadosSelecionado != '') ? Number(this.podersEstadosSelecionado.split('.')[0]) : 0;
			this.filtros.codigoEstado = (this.podersEstadosSelecionado != '') ? Number(this.podersEstadosSelecionado.split('.')[1]) : 0;
			this.data = [];
			PortalCredencialWebApi.getCredenciais(this.filtros,{
					PoderJudiciario: (this.podersEstadosSelecionado != '') ? Number(this.podersEstadosSelecionado.split('.')[0]) : 0,
					CodigoEstado: (this.podersEstadosSelecionado != '') ? Number(this.podersEstadosSelecionado.split('.')[1]) : 0,}
			)
				.then(res => {
					this.loading = false;
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Credencial", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Credencial", res.data.result);
					} else {
								this.podersEstados.push.apply(this.podersEstados, res.data.result.map(h => {
								return {poderJudiciario:h.poderJudiciario, codigoEstado: h.codigoEstado}
							}));
							this.data = res.data.result;
							this.pagination = { current: 1 };
						}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Credencial", "Erro ao tentar carregar Credencial.");
				});
		},
		fetch(params = {}) {
			this.loading = true;
			this.podersEstados = []
			this.getCredencialFonte();
			if (params.search) {
				params.idUsuario = this.$store.state.auth.idUser
				params.idPerfil = this.$store.state.auth.idPerfilPortal
				PortalCredencialWebApi.listarCredenciais(params
				).then(res => {
					this.loading = false;
					if (res.data.statusCode != 200) {
						showNotificationError(this, "Credencial", res.data.errorMessage);
						return;
					} else if (typeof res.data.result == "string") {
						showNotificationSucess(this, "Credencial", res.data.result);
					}
					else {
							this.podersEstados.push.apply(this.podersEstados, res.data.result.map(h => {
							return {poderJudiciario:h.poderJudiciario, codigoEstado: h.codigoEstado}
						}));
						this.data = res.data.result;
						this.pagination = { current: 1 };
					}
				})
				.catch(res => {
					this.loading = false;
					showNotificationError(this, "Credencial", "Erro ao tentar carregar usuários.");
				});
			} else {
				this.loading = false;
			}
		},
		handleSelecttipoPerfilChange(value) {
			    this.user.tipoPerfil = value;
				this.credencial.jusBr = false
		},	
		async onDownloadPlanModelo(){
			this.$root.loadingSpinner = true;
			PortalCredencialWebApi.downloadPlanilha()			
				.then(res => {
					this.$root.loadingSpinner = false;
					let data = res.data;					
					if (data !== null && typeof data !== "undefined") {
						let blob = new Blob([res.data], {
							type: "application/vnd.ms-excel"
						});
						let link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);
						link.download = "ModeloPlanilhaCredencial.xlsx";	
						
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						this.handleCancelDownloadPlan();
					} else {
						showNotificationError(this, "Download Planilha", "Erro ao tentar fazer o download.");
					}
				})
				.catch(res => {					
					this.$root.loadingSpinner = false;
					showNotificationError(this, "Download Planilha", "Erro ao tentar fazer o download.");
				});
		},
		chamarAPIEditarCredencial() {
			this.$root.loadingSpinner = true;
			this.idFonte = this.valueCredencialFonte;
			if(this.credencial.tipoCredencial != 2){
				this.credencial.jusBr = false
			}
			PortalCredencialWebApi.atualizarCredencial(this.credencial, this.$store.state.auth.idUser, this.idFonte, this.produtosSelecionados)
				.then(res => {
					this.handleCancelEditCredencialModal();
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
						showNotificationSucess(this, "Cadastro de Credencial", res.data.result);
						this.carregarCredenciais()						
					} else
						showNotificationError(this, "Cadastro de Credencial", res.data.errorMessage);
				})
				.catch(res => {
					console.log(res)
					this.$root.loadingSpinner = false;
					this.loading = false;
					showNotificationError(this, "Cadastro de Credencial", "Erro ao tentar editar Credencial.");
				});
		},
		onImportarPlanilha(){
			this.$root.loadingSpinner = true;
			if (this.termoAceite == false){
				this.$root.loadingSpinner = false;
				showNotificationError(this, "Carregar Planilha", "É obrigatório aceitar os termos!");
				return;
			}

			if (this.fileListUpload.length <= 0){
				this.$root.loadingSpinner = false;
				showNotificationError(this, "Carregar Planilha", "É obrigatório informar um arquivo!");
				return;
			}
			
			PortalCredencialWebApi.carregarPlanilha(this.fileListUpload[0], this.$store.state.auth.idUser, this.$store.state.auth.idPerfilPortal, this.termoAceite )
				.then(res => {					
					this.$root.loadingSpinner = false;
					if (res.data.statusCode == 200) {
                        showNotificationSucess(this, "Carregar Planilha", res.data.errorMessage);
						this.handleCancelPlanImport();
						this.handleCancelDownloadPlan();
						this.carregarCredenciais()	 
					} else {
						showNotificationError(this, "Carregar Planilha", res.data.errorMessage);
					}
				})
				.catch(res => {					
					this.$root.loadingSpinner = false;
					showNotificationError(this, "Carregar Planilha", "Erro ao tentar carregar a planilha.");
				});
		},
		// --------Chamadas endopoints - APIs (FIM) -----------------//

		// -----------Validação Credencial - (INICIO)-----------------//
		validarCampos(credencial){
			let camposValidos = true
			if (this.valueCredencialFonte == 0){
				showNotificationError(this, "Cadastro de Credencial", "Tribunal é um campo obrigatório!");
				camposValidos = false;
			}
			else if (credencial.usuario == ""){
				showNotificationError(this, "Cadastro de Credencial", "Usuário é um campo obrigatório!");
				camposValidos = false;
			}else if (credencial.senha == ""){
				showNotificationError(this, "Cadastro de Credencial", "Senha é um campo obrigatório!");
				camposValidos = false;
			}
			return camposValidos;
		},
		// -----------Validação Credencial - (FIM)-----------------//

		// -----------handles - GERAL (INICIO)-----------------//

		handleProdutoSelectionChange(value) {
			const newValue = value.filter(item => item !== "0");
      	   this.produtosSelecionados = newValue.length > 0 ? newValue : ["0"];
		},
		handlePoderEstadoChange(value) {
  			this.podersEstadosSelecionado = value == undefined ? '0.0' : `${value.poderJudiciario}.${value.codigoEstado}`;
		},
		handleTableChange(pagination, filters, sorter) {
			const pager = { ...this.pagination };
			pager.current = pagination.current;
      		this.pagination = pager;
		},
		handleTableChangeModal(pagination, filters, sorter) {
		const pager = { ...this.paginationModal };
		pager.current = pagination.current;
		this.paginationModal = pager;
		},
		handleClienteChange(value) {
			this.data = [];
			this.valueCliente = value;
			this.recuperarUsuario(value);
		},
		handleEditarCredencial(credencial) { 
			let fonteId =0
			this.credencialFontes.forEach(function(el, i){
				if(el.nome === credencial.nome) {
					fonteId = el.idDivisaoTribunal;
				}
			});
			this.credencial.idCredencial = credencial.idCredencial;
			this.valueCredencialFonte = fonteId;
			this.credencial.usuario = credencial.usuario;
			this.credencial.login = credencial.login;
			this.credencial.senha = credencial.senha;
			this.credencial.ordem = credencial.ordem;
			this.credencial.limite = credencial.limite;
			this.credencial.ativa = credencial.ativa;
			this.credencial.tipoCredencial = credencial.tipoCredencial;
			this.credencial.observacao = credencial.observacao;
			this.termoAceite = credencial.statusTermoUso;
			this.credencial.instancia = credencial.instancia;
			this.credencial.jusBr = credencial.jusBr;
			this.credencial.codigoMfa = credencial.codigoMfa;
			this.credencial.tipoDocumentoCaptura = credencial.tipoDocumentoCaptura || 2;
			this.produtosSelecionados = this.getCredencialProduto(credencial.idCredencial)
			this.$refs.modaleditcred.showModal();
		},
		
		handleCancelNewCred() {
			this.credencial.idCredencial = 0;
			this.idFonte = 0;
			this.credencial.usuario = '';
			this.credencial.login = '';
			this.credencial.senha = '';
			this.credencial.ativa = true;
			this.credencial.ordem = 0;
			this.credencial.limite = 0;
			this.termoAceite = false;
			this.credencial.instancia = '';
			this.valueCredencialFonte = '';
			this.selectedCredencialFonte = '';
			this.selectedInstancia = '';
			this.credencial.tipoCredencial = '';
			this.credencial.jusBr = false;
			this.credencial.codigoMfa = '';
			this.credencial.tipoDocumentoCaptura = 2;
			this.produtosSelecionados = ["0"]
			this.$refs.modalnewcred.handleCancel();
		},
		handleCancelModTermoAceite() {
			this.$refs.modalSalvarContrato.handleCancel();
			this.nomeFontesSelecionadas = '';
			this.termoAceite = false;
		},
		handleCancelDownloadPlan() {
			this.$refs.modalnewcred.handleCancel();
		},
		handleCancelPlanImport() {
			this.$refs.modalCarregarPlanilha.handleCancel();
			this.myFilesImport = '';
		},
		handleRemoveFile(file) {
			const index = this.fileListUpload.indexOf(file);
			const newFileList = this.fileListUpload.slice();
			newFileList.splice(index, 1);
			this.fileListUpload = newFileList;
		},
		handlerSwitchChange(value) {
			this.credencial.ativa = value;
		},
		handlerSwitchChangeJusBr(value) {
			this.credencial.jusBr = value  
		}, 
		handleOkEditCli() {			
			if (!this.validarCampos(this.credencial)){
				return;
			};

			if (this.credencial.ativa == true) {
				this.credencial.observacao = ''
			}
			this.chamarAPIEditarCredencial();
			
		},
		handleCancelEditCredencialModal() {			
			this.credencial.idUsuarioAlteracao = 0,
			this.credencial.idUsuarioCadastro = 0,
			this.credencial.idCredencial = 0;
			this.credencial.nome = '';
			this.credencial.usuario = '';
			this.credencial.senha = '';
			this.credencial.ativa = true;
			this.credencial.classe = '';
			this.credencial.ordem = 0;
			this.credencial.limite = 0;
			this.credencial.tipoCredencial = '';
			this.credencial.observacao = '';
			this.credencial.statusTermoUso = false;
			this.credencial.instancia = '';
			this.credencial.jusBr = false;
			this.credencial.codigoMfa = '';
			this.credencial.tipoDocumentoCaptura = 2;
			this.dataModal = [];
			this.produtosSelecionados = ["0"]
			this.$refs.modaleditcred.handleCancel();
		},
		handleChangeCredencialFonte(value) {
			
			this.valueCredencialFonte = value == undefined ? "" : value;
			this.selectedCredencialFonte = this.credencialFontes.find(credencial => credencial.IdDivisaoTribunal === value.idDivisaoTribunal);
			this.selectedInstancia = this.selectedCredencialFonte.instancia;
			this.credencial.instancia = this.selectedInstancia;

			// Verificar Lista
		},
		handleSelectTipoCredencialChange(value) {
			    this.credencial.tipoCredencial = value;
		},
		// -----------handles - GERAL (FIM)-----------------//

		// -----------onChange - GERAL (INICIO)-----------------//
		onChangeUsuario() {	
			this.filtros.login = this.valueUsuario == '' ? null : this.valueUsuario;
		},
		onChangeTribunal() {
			this.filtros.nome = this.valueTribunal == '' ? null : this.valueTribunal;	
		},
		onChangeInstancia(value) {
			this.valueInstancia = value == undefined ? '3' : value;
			this.filtros.instancia = this.valueInstancia == '3' ? 0 : this.valueInstancia;
		},
		onChangeAtivo(value){
			this.valueAtivo = value == undefined ? '3' : value;
			this.filtros.ativa = this.valueAtivo == '3' ? null : this.valueAtivo
		},
		onChangeCheck(e){
			this.termoAceite = e.target.checked;
			this.credencial.statusTermoUso = this.termoAceite;
			console.log(this.credencial.statusTermoUso)
		},
		// -----------onChange - GERAL (FIM)-----------------//

		// -----------Metodos - GERAIS (INICIO)-----------------//

		formatarCampoGrande(value, tamanho) {
      	    return value ? this.checkTamCampo(value, tamanho) ? value.slice(0, tamanho) + "..." : value : "";
       },
	   formatarTipoCredencial(value){
			return Helpers.formatarTipo(value);
		},
		validarNumero() {
      		this.valueNumeric = this.valueNumeric.replace(/[^0-9]/g, '');
    	},

		habilitarFuncionalidade(funcionalidade) {
			let retorno = Helpers.funcionalidadeAutorizada({
				idTela: this.idTela,
				funcionalidade: funcionalidade
			});
			return retorno;
		},
		onSearch(text) {
			this.textFilter = text;
			this.fetch({ search: true, Text: this.textFilter });
		},
		onNewCredencial() {
			this.handleCancelNewCred();
			this.perfisPortal = this.$store.state.auth.idPerfilPortal != 1 ? this.perfisPortalCompleto.filter(y => {
				return y.idPerfilPortal != 1;
			}) : this.perfisPortalCompleto;
			//Prencher o Campo Automaticamente
			let login = this.$store.state.auth.user;
			this.valueLogin = login;
			this.$refs.modalnewcred.showModal();
		},
		openLink(value) {
			window.open(value, '_blank');
 		},
		 formatarDataLocal(data, isDateTime, format) {
			return Helpers.formatarData(data, isDateTime, format);
		},
		onShowModalImportPlanilha() {
			this.fileListUpload = [];
			this.termoAceite = false;
			this.$refs.modalCarregarPlanilha.showModal();
		},
		beforeUploadFile(file) {
			this.fileListUpload = [];
			this.fileListUpload = [...this.fileListUpload, file];
			return false;
		},
	// -----------Metodos - GERAIS (FIM)-----------------//
	},  
	components: { ModalComponent }
};
</script>

<style scoped>
span {
	color: #000;
	font-family: "Segoe UI", "Segoe UI Emoji", "Segoe UI Symbol", "Courier New",
		Courier, monospace;
	font-weight: bold;
}

div .ant-row-flex {
	margin-top: 5px;
	margin-bottom: 10px;
}

.content {
  height: 100%;
}

.ant-layout {
  height: 100%;
  background: "#fff";
}

.ant-layout-content {
  height: 100%;
  background: #fff;
}

.ant-layout-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}
 
.cursor {
  cursor: pointer;
}

.cursor:hover {
  color: blue;
}

.danger {
	color: red;
}

.sucess {
	color: green;
}
.config-form-button {
	width: 100px;
}

.tr-ant-select {
	margin: 10px 0px 10px 0px;
} 
</style>

<style>
.credencial-form-button {
	width: 100px;
}
</style>

<style>
.campo-invalido .ant-input {
  border-color: red !important;
}
</style>
